export default __webpack_public_path__ + "static/media/ThinkForex.45c72d05cc22a910442552df6809955d.webp";